/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 22nd 2022, 4:47:44 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { DecisionMakingIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";
import { CONDITION_OPERATORS, isValueBasedCondition, ICondition } from "lib/schemas";

interface ConditionStatementProps {
  condition: ICondition & { readonly condition_field_label?: string; condition_value_rendered?: string };
  actions?: React.ReactNode;
}

export const ConditionStatement = ({ condition, actions }: ConditionStatementProps) => {
  const conditionFieldLabel = condition.condition_field_label;
  const conditionOperator = condition.condition_operator;
  const conditionValue = (["is_equal", "is_not_equal"] as (keyof typeof CONDITION_OPERATORS)[]).includes(
    condition.condition_operator
  )
    ? condition.condition_value_rendered || condition.condition_value
    : condition.condition_value;
  const conditionOperatorLabel = CONDITION_OPERATORS[conditionOperator];
  const conditionStatementMD = actions ? 8 : 12;

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={conditionStatementMD} sx={{ padding: 2 }}>
          <Stack direction="row" spacing={4}>
            <DecisionMakingIcon height={50} width={50} />

            <Typography variant="h5">If</Typography>

            <Typography color="secondary" variant="h6">
              {conditionFieldLabel}
            </Typography>

            <Typography variant="h5">{conditionOperatorLabel}</Typography>

            {isValueBasedCondition(conditionOperator) ? (
              <Typography color={COLORSCHEME.info} variant="h5">
                {conditionValue}
              </Typography>
            ) : null}
          </Stack>
        </Grid>
        {actions && (
          <>
            <Grid item xs={12} md={1}>
              <Divider orientation="vertical" />
            </Grid>
            <Grid item xs={12} md={3} sx={{ padding: 2 }}>
              {actions}
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};
